import { AssetModel, AssetModelType } from "common/model";

export const assets: { name: string; models: AssetModel[] }[] = [
  {
    name: "decoration",
    models: [
      {
        type: AssetModelType.DECORATION,
        name: "tree_desert",
        filename: "tree_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "tree_forest",
        filename: "tree_forest.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "detail_desert",
        filename: "detail_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "detail_forest",
        filename: "detail_forest.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "plantA_desert",
        filename: "plantA_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "plantA_forest",
        filename: "plantA_forest.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "plantB_desert",
        filename: "plantB_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "plantB_forest",
        filename: "plantB_forest.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "rocksA_desert",
        filename: "rocksA_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "rocksA_forest",
        filename: "rocksA_forest.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "rocksB_desert",
        filename: "rocksB_desert.gltf.glb",
      },
      {
        type: AssetModelType.DECORATION,
        name: "rocksB_forest",
        filename: "rocksB_forest.gltf.glb",
      },
    ],
  },
  {
    name: "ground",
    models: [
      {
        type: AssetModelType.GROUND,
        name: "tileLow_desert",
        filename: "tileLow_desert.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileLow_forest",
        filename: "tileLow_forest.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileLow_forest_ground",
        filename: "tileLow_forest_ground.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileMedium_desert",
        filename: "tileMedium_desert.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileMedium_forest",
        filename: "tileMedium_forest.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileHigh_desert",
        filename: "tileHigh_desert.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileHigh_forest",
        filename: "tileHigh_forest.gltf.glb",
      },
      {
        type: AssetModelType.GROUND,
        name: "tileHigh_desert_ground",
        filename: "tileHigh_desert_ground.glb",
      },
    ],
  },
  {
    name: "river",
    models: [
      {
        type: AssetModelType.RIVER,
        name: "tileLow_teamBlue",
        filename: "tileLow_teamBlue.gltf.glb",
      },
    ],
  },
  {
    name: "gem",
    models: [
      {
        type: AssetModelType.GEM,
        name: "diamond_teamRed",
        filename: "diamond_teamRed.gltf.glb",
      },
    ],
  },
  {
    name: "goal",
    models: [
      {
        type: AssetModelType.GOAL,
        name: "flag_teamRed",
        filename: "flag_teamRed.gltf.glb",
      },
    ],
  },
  {
    name: "condition",
    models: [
      {
        type: AssetModelType.CONDITION,
        name: "button_teamBlue",
        filename: "button_teamBlue.gltf.glb",
        metadata: {
          color: "#71cdfc",
        },
      },
      {
        type: AssetModelType.CONDITION,
        name: "button_teamRed",
        filename: "button_teamRed.gltf.glb",
        metadata: {
          color: "#fb3a69",
        },
      },
      {
        type: AssetModelType.CONDITION,
        name: "button_teamYellow",
        filename: "button_teamYellow.gltf.glb",
        metadata: {
          color: "#fdd73e",
        },
      },
    ],
  },
  {
    name: "character",
    models: [
      {
        type: AssetModelType.CHARACTER,
        name: "character_duck",
        filename: "character_duck.glb",
        rotation: true,
        offset: { x: 0, y: -0.4, z: 0 },
        scaling: { x: 1.2, y: 1.2, z: 1.2 },
      },
    ],
  },
];

/**
 * 名前からビルダーのアセット定義を引く
 *
 * common/model/tiles にも同名の定義があるが、あちらはコース用で offset / scaling が違う
 * （例: character_duck は offset.y=0・scaling.z=-1.2）。ビルダーに置くモデルは必ずこちらを使う
 */
export const findBuilderAsset = (name: string): AssetModel | undefined =>
  assets.flatMap((group) => group.models).find((model) => model.name === name);

export default assets;
